import { useState, useCallback } from 'react';

export default function useCaptchaFlow({
  turnstileActive,
  executeTurnstile,
  hasTurnstileToken,
  turnstileToken,
  resetTurnstile,
  hcaptchaRef,
}) {
  const [showHCaptcha, setShowHCaptcha] = useState(false);
  const [hcaptchaToken, setHcaptchaToken] = useState(null);
  const [turnstileAttempted, setTurnstileAttempted] = useState(false);
  const [captchaError, setCaptchaError] = useState(null);

  const handleHCaptchaVerify = useCallback((token) => {
    console.log('hCaptcha verified with token:', token);
    setHcaptchaToken(token);
    setCaptchaError(null);
  }, []);

  const handleHCaptchaExpire = useCallback(() => {
    console.log('hCaptcha token expired');
    setHcaptchaToken(null);
  }, []);

  const handleHCaptchaError = useCallback((error) => {
    console.error('hCaptcha error:', error);
    setCaptchaError('hCaptcha verificatie mislukt. Probeer opnieuw.');
    setHcaptchaToken(null);
  }, []);

  const resetAllCaptchas = useCallback(() => {
    console.log('Resetting all captchas');
    setShowHCaptcha(false);
    setHcaptchaToken(null);
    setTurnstileAttempted(false);
    setCaptchaError(null);

    if (turnstileActive) {
      resetTurnstile();
    }
    if (hcaptchaRef?.current) {
      try {
        hcaptchaRef.current.resetCaptcha();
      } catch (error) {
        console.warn('Error resetting hCaptcha:', error);
      }
    }
  }, [turnstileActive, resetTurnstile, hcaptchaRef]);

  const attemptTurnstileVerification = useCallback(async () => {
    if (!turnstileActive) {
      console.log('Turnstile not active, skipping');
      return null;
    }
    if (hasTurnstileToken) {
      console.log('Already have valid Turnstile token');
      return turnstileToken;
    }
    try {
      console.log('Attempting Turnstile verification...');
      const token = await executeTurnstile();
      console.log('Turnstile verification successful');
      return token;
    } catch (error) {
      console.error('Turnstile verification failed:', error);
      return null;
    }
  }, [turnstileActive, hasTurnstileToken, turnstileToken, executeTurnstile]);

  return {
    showHCaptcha,
    setShowHCaptcha,
    hcaptchaToken,
    setHcaptchaToken,
    captchaError,
    turnstileAttempted,
    setTurnstileAttempted,
    handleHCaptchaVerify,
    handleHCaptchaExpire,
    handleHCaptchaError,
    resetAllCaptchas,
    attemptTurnstileVerification,
  };
}


